module.exports = __webpack_public_path__ + "static/media/СЛ день.05982d79.jpg";